import { render } from "./Connect4Board.vue?vue&type=template&id=24e6e2ce&scoped=true"
import script from "./Connect4Board.js?vue&type=script&lang=js"
export * from "./Connect4Board.js?vue&type=script&lang=js"

import "./Connect4Board.scss?vue&type=style&index=0&id=24e6e2ce&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e6e2ce"]])

export default __exports__